import { API_KEYBOARD } from '../helpers/http/constansts';
import request from '../helpers/utils/request';
import keyboard from '../components/keyboard';
import keyboardSkeleton from '../components/keyboardSkeleton';

class Keyboard {
  constructor(SignatureDigital) {
    this.signatureDigital = SignatureDigital;
    this.queue = [];
  }

  addToken(token) {
    this.queue.push(token);
  };

  clearToken() {
    this.queue = [];
  }

  updateInputValue = (clear) => {
    const input = document.querySelector('#signature-digital__input');
    input.value = clear ? '' : input.value + '*';
  }

  toggleError = (message) => {
    const spanError = document.querySelector('.signature-digital__error');

    if(spanError) {
      spanError.classList.toggle('signature-digital__error--show');

      if (message) {
        spanError.innerText = message;
      }
    }
  }

  clearKeyboard() {
    this.clearToken();
    this.updateInputValue(true);

    this.signatureDigital.subscribe(this.signatureDigital.tokens.length);
  }

  renewKeyboard() {
    const minutes = 10;
    const timer = minutes * 60 * 1000;

    setTimeout(() => {
      this.clearKeyboard();
      this.render(true);
    }, timer);
  }

  actions() {
    const buttons = document.querySelectorAll('#signature-digital__group button');
    let i = buttons.length;

    const onClickButton = (e) => {
      const targetValue = e.target.getAttribute("hash-id");

      if (!!targetValue) {
        this.updateInputValue();
        this.addToken(targetValue);
      } else {
        this.updateInputValue(true);
        this.clearToken();
      }

      this.signatureDigital.subscribe(this.signatureDigital.tokens.length);
    }

    while (i--) {
      buttons[i].addEventListener('click', onClickButton);
    }
  }

  render(reload) {
    const signatureDigitalGroup = document.querySelector('#signature-digital__group');
    const isRendered = signatureDigitalGroup.querySelectorAll('button').length;

    if (isRendered && !reload) return null;

    this.renewKeyboard();

    // render skeleton
    signatureDigitalGroup.innerHTML = keyboardSkeleton();

    request(API_KEYBOARD, { method: 'GET', type: 'keyboard' }, (response) => {
      // set authorization code
      this.signatureDigital.setAuthorization(response.authorization);
      // inject keyboard
      signatureDigitalGroup.innerHTML = keyboard(response.data);
      // init keyboard actions
      this.signatureDigital._keyboard.actions();
    });
  }

  get tokens() {
    return this.queue;
  }
}

export default Keyboard;